import { Collapsible, CollapsibleProps } from "@shopify/polaris"
import { uniqueId } from "lodash-es"
import { useRef } from "react"

import { scrollToNode } from "../ProFocusBox/Focus"

export const ProCollapsible = (
  props: Omit<CollapsibleProps, "id"> & { id?: any },
) => {
  const { onAnimationEnd, ...rest } = props
  const backId = useRef("pro-collapsible-" + uniqueId())
  const id = props.id || backId.current
  return (
    <Collapsible
      {...rest}
      id={id}
      onAnimationEnd={() => {
        onAnimationEnd?.()
        if (rest.open) {
          scrollToNode({
            selector: `#${id}`,
            delay: 0,
          })
        }
      }}
    >
      {props.children}
    </Collapsible>
  )
}
